var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.905 30.905",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.63,454.126a15.453,15.453,0,1,1,15.453-15.453h0a15.474,15.474,0,0,1-15.453,15.453m0-29.781a14.326,14.326,0,1,0,14.326,14.326h0a14.342,14.342,0,0,0-14.326-14.325",
    transform: "translate(-601.177 -423.221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.9,445.617a7.99,7.99,0,0,0,2.193-4.088h-2.8a.733.733,0,0,0-.381.1l-.53.321a.617.617,0,0,1-.469.063.48.48,0,0,1-.323-.26l0-.014-.4-1.126-.983,5.121a.278.278,0,0,1-.282.208h-.013a.272.272,0,0,1-.274-.23L618,438.753h-.1l-.739,5.811a.277.277,0,0,1-.278.223.282.282,0,0,1-.291-.211l-.854-4.723-.625,3.254a.278.278,0,0,1-.265.208.286.286,0,0,1-.291-.184l-.9-2.854-.42.809a1.162,1.162,0,0,1-1.1.624h-2.774a8.043,8.043,0,0,0,13.536,3.909",
    transform: "translate(-602.135 -425.038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.3,441.9a9.232,9.232,0,0,1-2.153,4.5l2.208,2.208.724-.724.706.706a12.763,12.763,0,0,0,2.548-6.691Z",
    transform: "translate(-604.098 -425.405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.187,431.878a5.319,5.319,0,0,1,4.415,2.236,9.146,9.146,0,0,0-2.146-1.06,7.287,7.287,0,0,0-4.53,0,9.108,9.108,0,0,0-2.146,1.06,5.325,5.325,0,0,1,4.411-2.236M612.676,440l.011-.022.751-1.453a.3.3,0,0,1,.284-.146.278.278,0,0,1,.253.184l.764,2.427.706-3.651a.3.3,0,0,1,.566,0l.795,4.4.892-7.019a.278.278,0,0,1,.291-.223.27.27,0,0,1,.281.23l.732,8.01.795-4.15a.273.273,0,0,1,.265-.208.288.288,0,0,1,.292.177l.734,2.045.478-.291a1.371,1.371,0,0,1,.706-.191h2.885a8.045,8.045,0,1,0-15.91.177h2.867a.6.6,0,0,0,.562-.3",
    transform: "translate(-602.109 -424.126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.2,450.225l.725-.724-2.208-2.208a9.265,9.265,0,0,1-15.206-5.192h-3.3a12.83,12.83,0,0,0,20.717,8.854Z",
    transform: "translate(-601.532 -425.429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.419,439.724a9.272,9.272,0,1,1,18.383-.177h3.99c.007-.177.011-.358.011-.54a12.83,12.83,0,1,0-25.659-.211c0,.071,0,.14,0,.211,0,.24.007.481.02.719Z",
    transform: "translate(-601.524 -423.554)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill7);
export default __webpack_public_path__ + "static/media/skill7.0592d779.svg";
export { ForwardRef as ReactComponent };